/**
 * @file Especialização URL do pipeline Input.
 * @module components/create/url
 * @see module:components/create/input
 */

/**
 * Configura input textual com validação de URL no blur.
 *
 * O tipo HTML permanece `text`; a validação é feita pelo helper EP `checkUrl()`.
 *
 * @param {HTMLInputElement} elem Input base.
 * @param {Object} options Opções recebidas pelo componente.
 * @param {Function} [options.callback] Callback associado à validação. O runtime o repassa a `checkUrl()` e também o executa explicitamente após a validação no blur.
 * @returns {Array.<HTMLInputElement|Object>} Input e o mesmo objeto `options` normalizado.
 * @see module:components/create/input
 */
export default (elem, options) => {
  options.type = 'text';

  if (options.callback !== undefined && typeof options.callback === 'function') {
    elem.callback = options.callback;
  }

  elem.addEventListener('blur', (e) => {
    e.target.checkUrl(e.target.callback);

    if (typeof e.target.callback === 'function') {
      e.target.callback(e);
    }
  });

  return [elem, options];
}
